module.exports = __webpack_public_path__ + "img/experience--personal.8bb32880.png";